<template>
  <action-dispatcher
    action="marketplace/getProducts"
    ref="actionDispatcher"
    class="view-marketplace container-fluid py-5"
  >
    <template v-if="product">
      <div class="mb-5">
        <router-link
          :to="{ name: 'home' }"
          class="text-secondary font-weight-bold"
          >Home</router-link
        >
        <i class="icon-chevron-right mx-2 text-secondary"></i>
        <router-link
          :to="{ name: 'marketplace' }"
          class="text-secondary font-weight-bold"
          >Clube de Benefícios</router-link
        >
        <i class="icon-chevron-right mx-2 text-secondary"></i>
        <strong>{{ product.title }}</strong>
      </div>

      <div class="row">
        <div class="col-lg-4">
          <div
            class="img-cover"
            :style="`background-image: url(${product.picture})`"
          ></div>
        </div>
        <div class="col-lg-8">
          <h3 class="mb-4">{{ product.title }}</h3>
          <h5 v-if="product.installments" class="text-success mb-4">
            <span v-if="product.promotion">
              De:
              <small>
                <del>R$ {{ product.price }}</del>
              </small>
              <br />
              Por: R$ {{ product.promotion }}
              <br />
              Ou
              {{ product.installments }}X de {{ promotionInstallmentsPrice }}
            </span>
            <span v-else>
              R$ {{ product.price }}
              <br />
              Ou {{ product.installments }}X de {{ installmentsPrice }}
            </span>
          </h5>
          <h5 v-else-if="product.promotion" class="text-success mb-4">
            De:
            <small
              ><del
                >R$ {{ product.price }}
                <span class="text-capitalize"></span></del
            ></small>
            <br />Por: R$ {{ product.promotion }}
            <span class="text-capitalize"></span>
          </h5>
          <h5 v-else class="text-success mb-4">
            R$ {{ product.price }}
            <span class="text-capitalize"></span>
          </h5>
          <div class="mb-4" v-html="product.description" />
          <a class="btn btn-primary px-5" :href="product.url" target="_blank">
            Participar
          </a>
        </div>
      </div>
    </template>
  </action-dispatcher>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      search: ""
    };
  },
  computed: {
    ...mapState("marketplace", ["products"]),
    product() {
      return this.products.find(p => `${p.id}` === `${this.$route.params.id}`);
    },
    promotionInstallmentsPrice() {
      return (this.product.promotion / this.product.installments).toFixed(2);
    },
    installmentsPrice() {
      return (this.product.price / this.product.installments).toFixed(2);
    }
  }
};
</script>

<style lang="scss" scoped>
.view-marketplace {
  .card {
    background: rgba(0, 0, 0, 0.2);
    border-color: white;
    border-radius: 6px;
  }

  hr {
    border-color: rgba(255, 255, 255, 0.7);
  }

  ::v-deep .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: unset;
  }

  .img-cover {
    width: 100%;
    height: 0;
    padding-bottom: 60%;
    background-color: rgba(10, 5, 15, 0.7);
    background-size: contain;
    background-position-x: center;
    background-position-y: center;
    border-radius: 4px;
  }
}
</style>
